export default {
  middleware_url: "https://dev.ltm-warning.fluid-it.fr",
  cake_url: "https://cake.dev.ltm-warning.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  instancePrefix: "09",
  googleMap: {
    api: "AIzaSyBC_3j0i4FLr0PU5C0dEJg0W8peGoLkVZM",
  },
};
